import service from '@/store/services/seguroicontratars-service';

const state = {
  list: {},
  seguroicontratar: {},
  meta: {},
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, seguroicontratar) => {
    state.seguroicontratar = seguroicontratar;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  }
};

const actions = {
  list({commit, dispatch}, params) {
    return service.list(params)
      .then(({list, meta}) => {
        commit('SET_LIST', list);
        commit('SET_META', meta);
      });
  },

  get({commit, dispatch}, params) {
    return service.get(params)
      .then((seguroicontratar) => { commit('SET_RESOURCE', seguroicontratar); });
  },

  baixarArquivo({ commit, dispatch }, params) {
    // Chama a função do serviço para baixar o PDF
      return service.downloadPDF(params[0],params[1])
        .then((resposta) => {
          // Manipular a resposta, se necessário
          //console.log("PDF baixado com sucesso!", resposta);
          return resposta;
        })
        .catch((erro) => {
          // Lidar com erros, como usuário não autenticado
          console.error("Erro ao baixar a apólice:", erro);
          throw erro;
        });
  },

  add({commit, dispatch}, params) {
    return service.add(params)
      .then((seguroicontratar) => { commit('SET_RESOURCE', seguroicontratar); });
  },

  update({commit, dispatch}, params) {
    return service.update(params)
      .then((seguroicontratar) => { commit('SET_RESOURCE', seguroicontratar); });
  },

  destroy({commit, dispatch}, params) {
    return service.destroy(params);
  },
};

const getters = {
  list: state => state.list,
  listTotal: state => state.meta.page.total,
  seguroicontratar: state => state.seguroicontratar,
  dropdown: (state) => {
    return state.list.map(seguroicontratar => ({
      id: seguroicontratar.id,
      name: seguroicontratar.name,
      seguroincendio_id: seguroicontratar.seguroincendio?.id,
      seguroiparcelamento_id: seguroicontratar.seguroiparcelamento?.id
    }));
  }
};

const seguroicontratars = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default seguroicontratars;
